import React from 'react'
import Profile from '../component/Entrepreneurbiio/Profile'
import Profilesec1 from '../component/Entrepreneurbiio/Profilesec1'

const EntrepreneurProfile = () => {
   window.scrollTo({ top: 0, behavior: 'smooth' });
  return (
    <div>
      <Profilesec1/>
      <Profile/>
    </div>
  )
}

export default EntrepreneurProfile
